import { EntitiesColorsProvider } from 'contexts/EntitiesColorsContext'

import { useTaxonomyChildrenTabModel } from './taxonomy-children-tab.model'
import type { ITaxonomyChildrenTabProps } from './taxonomy-children-tab.types'
import { TaxonomyChildrenTabView } from './taxonomy-children-tab.view'

export const TaxonomyChildrenTab = (props: ITaxonomyChildrenTabProps) => {
  const taxonomyChildrenTabModel = useTaxonomyChildrenTabModel(props)
  return (
    <EntitiesColorsProvider>
      <TaxonomyChildrenTabView {...taxonomyChildrenTabModel} />
    </EntitiesColorsProvider>
  )
}
